var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:(_vm.classes + " md:flex max-md:px-4 md:basis-4/5 md:pr-0"),attrs:{"data-component":"accordion"}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }